import React, { useCallback, useEffect, useState } from 'react';
import { Snackbar, TSnackbarPosition, useMediaQuery } from '@agco-onedigital/ecosystem-lib-web-components';
import { getDefaultSnackPosition } from './utils';

const SnackProvider = () => {
  const isMobile = useMediaQuery({ device: 'mobileSm', filter: 'max' });
  const [snackPosition, setSnackPosition] = useState<TSnackbarPosition>(getDefaultSnackPosition(isMobile));

  const handleResize = useCallback(() => {
    const newSnackPosition = getDefaultSnackPosition(isMobile);
    if (snackPosition !== newSnackPosition) {
      setSnackPosition(newSnackPosition);
    }
  }, [snackPosition, isMobile]);

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize, isMobile]);

  return <Snackbar maxShownSnacks={1} position={snackPosition} />;
};

export default SnackProvider;
